export const ROLES = {
  anonymous: 'anonymous',
  user: 'user',
  causeEntrepreneur: 'Cause Entrepreneur',
  superAdmin: 'superAdmin',
  permissions: {
    account: {
      READ: true,
      WRITE: true,
    },
    home: {
      READ: true,
      WRITE: true,
    },
    shop: {
      READ: true,
      WRITE: true,
    },
  },
  users: {
    superadmin: 'superadmin',
    admin: 'admin',
    via: 'via',
    vip: 'vip',
  },
};

export const Errors = {
  RequiredField: 'This field is required.',
  EnterValidEmail: 'Please enter a valid email.',
  EnterValidPhone: 'Please enter a valid phone number.',
  EnterValidPassword: 'Please enter a valid password.',
  InvalidEmail: 'The email you entered could not be found. Please sign up!',
  AccountAlreadyExists: 'An account with this email already exists.',
  EmailAlreadyTaken: 'User with email already exists.',
  EmailAlreadyTakenBySSO: 'Please login with Facebook or Google.',
  // TODO EmailAlreadyTakenByFacebookSSO & FacebookAccountAlreadyExists are the same
  EmailAlreadyTakenByFacebookSSO:
    'An account was created through Facebook. Please sign in through Facebook Login.',
  EmailAlreadyTakenByGoogleSSO:
    'An account was created through Google. Please sign in through Google Login',
  InvalidToken: 'Invalid SSO token.',
  WrongEmailOrPassword: 'Email or password is incorrect.',
  AutocreatedAccountFirstLogin: `We recognize you! Click below for a one-time password reset.`,
  VerificationNeeded: `We need to verify your email address! Click below for a one-time password reset.`,
  WrongPassword:
    'Password is invalid. Please try again or click "Forgot Password?"',
  WeakPassword:
    'Include a number or add characters to make your password stronger.',
  UnregisteredAccount: 'You must sign up before logging in.',
  GoogleAccountDoesNotExist: 'You must sign up before logging in with Google.',
  FacebookAccountDoesNotExist:
    'You must sign up before logging in with Facebook.',
  FacebookAccountAlreadyExists:
    'An account has been created through Facebook. Please sign in through Facebook Login.',
  GoogleAccountAlreadyExists:
    'An account has been created through Google. Please sign in through Google Login.',
  ResetPassword:
    'Invalid Token. Please reset your password using the login form.',
  MultiEmailAccountsUnsupported:
    'SSO account connection does not support multi-email connection.',
  ShoppingWithCeoAccountIdTaken:
    'Customer email already registered with another CEO',
  AccountIsTryingToShopForSelf:
    'To shop for yourself, simply click the event link.',
  AccountIsACE:
    'Sorry, this user is a CE and cannot be added as your customer.',
  AccountCannotBeCustomer: 'This account cannot be a customer',
  AccountBelongsToAnotherCE:
    'Customer is already shopping with a different Cause Entrepreneur. Please contact support@onehopewine.com for assistance.',
  SSONotAuthorized: name =>
    `We're sorry, but you are not authorized to login to ${name}. Please contact support@onehopewine.com if you feel this is a mistake.`,
  TaxIdAlreadyInUse:
    'The tax ID you input is already in use by another Non-Profit',
  CustomUrlWasNotSaved: 'Your account URL was not saved',
  CustomUrlAlreadyExists:
    'Account URL is already in use. Please choose a different URL',
};
